import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import CardBox from "components/ui/controls/card-box/card-box";
import Button from "components/ui/controls/button/button";
import { applyFormat } from "components/ui/ui-helpers";
import Modal from "components/ui/modal/modal";
import { useContext, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import { FaEye, FaGlobe } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { createStyledButton } from "components/ui/controls/button/button-styles";

const getIconStyle = (value) => {
  if (value > 0) {
    return { color: '#4CAF50', backgroundColor: '#E8F5E8' };
  } else {
    return { color: '#9E9E9E', backgroundColor: '#F5F5F5' };
  }
};

const DetailImpot = (props) => {
  const { DetailImpot, DetailAssiette, DetailAssietteConjoint } = props;
  const context = useContext(AppContext);
  const [modalRevenusClientOpen, setmodalRevenusClientOpen] = useState(false);
  const [modalDividendeOpen, setmodalDividendeOpen] = useState(false);
  const [modalRevenusConjointOpen, setmodalRevenusConjointOpen] = useState(false);

  return (
    "Dirigeant" in DetailImpot && (
      <>
        <Column fill>
          <CardBox>
            <Column fill>
              <Row>
                <div className="cotisations-container">
                  <div className="cotisations-list-container">
                    <div className="cotisations-header">
                      <div className="header-column"></div>
                      <div className="header-column">Élément</div>
                      <div className="header-column">Montant</div>
                      <div className="header-column">+/-</div>
                      <div className="header-column">Détail</div>
                    </div>
                    
                    <div className="cotisations-card light-title">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                          color: '#ffffff'
                        }}
                      >
                        🏛️
                      </div>
                      <div className="card-column">Impôt sur le revenu</div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                    </div>
                    
                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                          color: '#ffffff'
                        }}
                      >
                        💼
                      </div>
                      <div className="card-column">Revenus d'activités imposables {context.state.Prenom}</div>
                      <div className="card-column">
                        {applyFormat(Math.max(0, DetailImpot.Dirigeant.NetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                      </div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column">
                        <Button
                          onClick={() => {
                            setmodalRevenusClientOpen(true);
                          }}
                          icon
                          style={{
                            display: "inline-flex",
                            padding: '8px',
                            backgroundColor: '#dbeafe',
                            color: '#2563eb',
                            border: 'none',
                            borderRadius: '6px',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                          }}
                        >
                          <FaEye style={{ color: '#2563eb', fontSize: '12px' }} />
                        </Button>
                      </div>
                    </div>

                    {(context.state.InclureConjoint || DetailImpot.Conjoint?.AutresRevenusActivite > 0) === true && (
                      <div className="cotisations-card">
                        <div 
                          className="cotisations-card-icon" 
                          style={{ 
                            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                            color: '#ffffff'
                          }}
                        >
                          👥
                        </div>
                        <div className="card-column">Revenus d'activités imposables {context.state.PrenomConjoint}</div>
                        <div className="card-column">
                          {applyFormat(Math.max(0, DetailImpot.Conjoint.NetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                        </div>
                        <div className="card-column">
                          <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                        </div>
                        <div className="card-column">
                          {DetailAssietteConjoint !== undefined && (
                            <Button
                              onClick={() => {
                                setmodalRevenusConjointOpen(true);
                              }}
                              icon
                              style={{
                                display: "inline-flex",
                                padding: '8px',
                                backgroundColor: '#dbeafe',
                                color: '#2563eb',
                                border: 'none',
                                borderRadius: '6px',
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                              }}
                            >
                              <FaEye style={{ color: '#2563eb', fontSize: '12px' }} />
                            </Button>
                          )}
                        </div>
                      </div>
                    )}

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                          color: '#ffffff'
                        }}
                      >
                        💰
                      </div>
                      <div className="card-column">Dividendes nets imposables (BPI)</div>
                      <div className="card-column">
                        {applyFormat(Math.max(0, DetailImpot.DividendeNetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                      </div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column">
                        <Button
                          onClick={() => {
                            setmodalDividendeOpen(true);
                          }}
                          icon
                          style={{
                            display: "inline-flex",
                            padding: '8px',
                            backgroundColor: '#dbeafe',
                            color: '#2563eb',
                            border: 'none',
                            borderRadius: '6px',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer',
                          }}
                        >
                          <FaEye style={{ color: '#2563eb', fontSize: '12px' }} />
                        </Button>
                      </div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                          color: '#ffffff'
                        }}
                      >
                        📊
                      </div>
                      <div className="card-column">Autres revenus nets imposables</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.AutresRevenus), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                          color: '#ffffff'
                        }}
                      >
                        📉
                      </div>
                      <div className="card-column">Déductions fiscales spécifiques</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.DeductionFiscale), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '18px' }}>-</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                          color: '#ffffff'
                        }}
                      >
                        🏦
                      </div>
                      <div className="card-column">Cotisations épargne retraite déductibles</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.DeductionPerp+DetailImpot.DeductionPerpConjoint), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '18px' }}>-</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card light-title">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                          color: '#4f46e5'
                        }}
                      >
                        🎯
                      </div>
                      <div className="card-column">Base imposable</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '20px' }}>{applyFormat(Math.max(0, DetailImpot.BaseImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '10px' }}>
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>=</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                          color: '#ffffff'
                        }}
                      >
                        ⚖️
                      </div>
                      <div className="card-column">Impôt avant quotient familial</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.IRavantQF), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                          color: '#ffffff'
                        }}
                      >
                        👨‍👩‍👧‍👦
                      </div>
                      <div className="card-column">Quotient familial</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.QF), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card light-title">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                          color: '#4f46e5'
                        }}
                      >
                        📋
                      </div>
                      <div className="card-column">Impôt après quotient familial</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '20px' }}>{applyFormat(Math.max(0, DetailImpot.IRapresQF), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '10px' }}>
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>=</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                          color: '#ffffff'
                        }}
                      >
                        🎁
                      </div>
                      <div className="card-column">Réductions et crédits d'impôt</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.ReductionImpot), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '18px' }}>-</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                          color: '#ffffff'
                        }}
                      >
                        📊
                      </div>
                      <div className="card-column">Décote</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.Decote), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '18px' }}>-</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card light-title">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                          color: '#4f46e5'
                        }}
                      >
                        📄
                      </div>
                      <div className="card-column">Impôt après réductions, crédits d'impôt et décote</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '20px' }}>{applyFormat(Math.max(0, DetailImpot.IRapresQF-DetailImpot.ReductionImpot-DetailImpot.Decote), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '10px' }}>
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>=</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)',
                          color: '#ffffff'
                        }}
                      >
                        📈
                      </div>
                      <div className="card-column">PFU au taux de 12,8%</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.PFU), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
                          color: '#ffffff'
                        }}
                      >
                        💎
                      </div>
                      <div className="card-column">Contribution exceptionnelle sur les hauts revenus (CEHR)</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.ContribHR), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column"></div>
                    </div>
                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)',
                          color: '#ffffff'
                        }}
                      >
                        💎
                      </div>
                      <div className="card-column">Contribution différentielle sur les Hauts Revenus (CDHR)</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.CDHRAjustee), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                          color: '#ffffff'
                        }}
                      >
                        🏥
                      </div>
                      <div className="card-column">Prélèvements sociaux</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.PrelevementsSociaux), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">
                        <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '18px' }}>+</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card light-title">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                          color: '#ffffff'
                        }}
                      >
                        🏛️
                      </div>
                      <div className="card-column">Impôt total</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '20px' }}>{applyFormat(Math.max(0, DetailImpot.IRTotal), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column" style={{ display: 'flex', justifyContent: 'center', paddingRight: '20px' }}>
                        <span style={{ color: '#22c55e', fontWeight: 'bold', fontSize: '18px' }}>=</span>
                      </div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #64748b 0%, #475569 100%)',
                          color: '#ffffff'
                        }}
                      >
                        📊
                      </div>
                      <div className="card-column">TMI applicable</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.Tmi), "uint", { thousands: " ", decimal: ",", unit: "%" })}</div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                    </div>

                    <div className="cotisations-card">
                      <div 
                        className="cotisations-card-icon" 
                        style={{ 
                          background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                          color: '#ffffff'
                        }}
                      >
                        👨‍👩‍👧‍👦
                      </div>
                      <div className="card-column">Nombre de parts fiscales</div>
                      <div className="card-column">{applyFormat(Math.max(0, DetailImpot.PartFiscale), "ufloat", { thousands: " ", decimal: ",", precision: 2 })}</div>
                      <div className="card-column"></div>
                      <div className="card-column"></div>
                    </div>
                  </div>
                </div>
              </Row>
            </Column>
          </CardBox>
        </Column>

        <Modal
          width="40%"
          height="50%"
          title="Rémunération nette imposable "
          icon={<FaGlobe />}
          visible={modalRevenusClientOpen}
          onClose={() => {
            setmodalRevenusClientOpen(false);
          }}
        >
          {"AssietteFicheDePaie" in DetailAssiette ? (
            <DetailRevenusImposablesSalarie DetailImpot={DetailImpot.Dirigeant} DetailAssiette={DetailAssiette} />
          ) : (
            <DetailRevenusImposablesTNS DetailImpot={DetailImpot.Dirigeant} DetailAssiette={DetailAssiette} />
          )}
        </Modal>
        <Modal
          width="40%"
          height="50%"
          title="Rémunération nette imposable"
          icon={<FaGlobe />}
          visible={modalRevenusConjointOpen}
          onClose={() => {
            setmodalRevenusConjointOpen(false);
          }}
        >
          {DetailAssietteConjoint !== undefined && (
            <>
              {"AssietteFicheDePaie" in DetailAssietteConjoint ? (
                <DetailRevenusImposablesSalarie DetailImpot={DetailImpot.Conjoint} DetailAssiette={DetailAssietteConjoint} />
              ) : (
                <DetailRevenusImposablesTNS DetailImpot={DetailImpot.Conjoint} DetailAssiette={DetailAssietteConjoint} />
              )}
            </>
          )}
        </Modal>
        <Modal
          width="40%"
          height="50%"
          title="Dividendes imposables"
          icon={<FaGlobe />}
          visible={modalDividendeOpen}
          onClose={() => {
            setmodalDividendeOpen(false);
          }}
        >
          <DetailDividendes DetailImpot={DetailImpot} />
        </Modal>
      </>
    )
  );
};

export default DetailImpot;

const DetailRevenusImposablesTNS = (props) => {
  const { DetailImpot, DetailAssiette } = props;
  return (
    <Pager
      pages={[
        {
          content: (
            <Column fill>
              <CardBox>
                <Column fill>
                  <Row>
                    <div className="cotisations-container">
                      <div className="cotisations-list-container">
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📊
                          </div>
                          <div className="card-column">Rémunération nette sur l'activité étudiée</div>
                          <div className="card-column" style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '20px' }}>{applyFormat(parseInt(DetailAssiette.DetailRemunerationNette) || 0, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🏥
                          </div>
                          <div className="card-column">CSG non déductible + CRDS</div>
                          <div className="card-column">{applyFormat(parseInt(DetailAssiette.DetailCsgNd) || 0, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                              color: '#ffffff'
                            }}
                          >
                            💰
                          </div>
                          <div className="card-column">Cotisations facultatives non déductibles</div>
                          <div className="card-column">
                            {applyFormat(
                              parseInt(
                                Number(DetailImpot.MadelinNonDeductible) +
                                  DetailAssiette.Depassement +
                                  Number(DetailImpot.AssuranceVieEntreprise) +
                                  Number(DetailImpot.PerpPerToutPublicEntreprise)
                              ) || 0,
                              "uint",
                              { thousands: " ", decimal: ",", unit: " €" }
                            )}
                          </div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🎁
                          </div>
                          <div className="card-column">Avantages en nature</div>
                          <div className="card-column">{applyFormat(parseInt(DetailAssiette.DetailAvantageNature)||0, "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card light-title" style={{ borderTop: "1px solid black" }}>
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                              color: '#4f46e5'
                            }}
                          >
                            🎯
                          </div>
                          <div className="card-column">Rémunération imposable</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.BrutImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📊
                          </div>
                          <div className="card-column">Autres revenus d'activité</div>
                          <div className="card-column">
                            {applyFormat(Math.max(0, Number(DetailImpot.AutresRevenusActivite)), "uint", {
                              thousands: " ",
                              decimal: ",",
                              unit: " €",
                            })}
                          </div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📉
                          </div>
                          <div className="card-column">Abattement</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.Abattement), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card light-title">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🏛️
                          </div>
                          <div className="card-column">Net imposable</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.NetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Column>
              </CardBox>
            </Column>
          ),
        },
      ]}
      page={0}
      navButtons={{}}
    />
  );
};

const DetailRevenusImposablesSalarie = (props) => {
  const { DetailImpot, DetailAssiette } = props;
  return (
    <Pager
      pages={[
        {
          content: (
            <Column fill>
              <CardBox>
                <Column fill>
                  <Row>
                    <div className="cotisations-container">
                      <div className="cotisations-list-container">
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              color: '#ffffff'
                            }}
                          >
                            💼
                          </div>
                          <div className="card-column">Salaire net sur l'activité étudiée</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailAssiette.TabRecap?.RecapSalaireNet), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🏥
                          </div>
                          <div className="card-column">CSG non déductible + CRDS</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailAssiette.TabRecap?.CsgNonDeductible), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                              color: '#ffffff'
                            }}
                          >
                            💰
                          </div>
                          <div className="card-column">Cotisations facultatives non déductibles</div>
                          <div className="card-column">
                            {applyFormat(
                              Math.max(0, Number(DetailImpot.MadelinNonDeductible) + Number(DetailImpot.AssuranceVieEntreprise) + Number(DetailImpot.PerpPerToutPublicEntreprise)),
                              "uint",
                              { thousands: " ", decimal: ",", unit: " €" }
                            )}
                          </div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🎁
                          </div>
                          <div className="card-column">Avantages en nature</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailAssiette.AssietteFicheDePaie.InfoAvantageNature), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🔄
                          </div>
                          <div className="card-column">Réintégration 83</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailAssiette.TabRecap?.Reintegration83), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card light-title" style={{ borderTop: "1px solid black" }}>
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                              color: '#4f46e5'
                            }}
                          >
                            🎯
                          </div>
                          <div className="card-column">Rémunération imposable</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.BrutImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📊
                          </div>
                          <div className="card-column">Autres revenus d'activité</div>
                          <div className="card-column">
                            {applyFormat(Math.max(0, Number(DetailImpot.AutresRevenusActivite)), "uint", {
                              thousands: " ",
                              decimal: ",",
                              unit: " €",
                            })}
                          </div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📉
                          </div>
                          <div className="card-column">Abattement</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.Abattement), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card light-title">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🏛️
                          </div>
                          <div className="card-column">Net imposable</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.NetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Column>
              </CardBox>
            </Column>
          ),
        },
      ]}
      page={0}
      navButtons={{}}
    />
  );
};

const DetailDividendes = (props) => {
  const { DetailImpot } = props;
  return (
    <Pager
      pages={[
        {
          content: (
            <Column fill>
              <CardBox>
                <Column fill>
                  <Row>
                    <div className="cotisations-container">
                      <div className="cotisations-list-container">
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                              color: '#ffffff'
                            }}
                          >
                            💰
                          </div>
                          <div className="card-column">Dividendes bruts issus des activités étudiées</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.DividendeBrutImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                              color: '#ffffff'
                            }}
                          >
                            💼
                          </div>
                          <div className="card-column">Autres dividendes bruts</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.AutreDividendeBrutImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                              color: '#ffffff'
                            }}
                          >
                            📉
                          </div>
                          <div className="card-column">Abattement 40%</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.AbattementDividende), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                        <div className="cotisations-card light-title">
                          <div 
                            className="cotisations-card-icon" 
                            style={{ 
                              background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                              color: '#ffffff'
                            }}
                          >
                            🏛️
                          </div>
                          <div className="card-column">Dividendes nets</div>
                          <div className="card-column">{applyFormat(Math.max(0, DetailImpot.DividendeNetImposable), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </Column>
              </CardBox>
            </Column>
          ),
        },
      ]}
      page={0}
      navButtons={{}}
    />
  );
};
